import { render, staticRenderFns } from "./levels.vue?vue&type=template&id=4e40bdd3&scoped=true&"
import script from "./levels.vue?vue&type=script&lang=js&"
export * from "./levels.vue?vue&type=script&lang=js&"
import style0 from "./levels.vue?vue&type=style&index=0&id=4e40bdd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e40bdd3",
  null
  
)

export default component.exports